/** @format */

import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import { Button, Spin, Col, Row, Popover, Avatar, Select } from 'antd'
import { UserOutlined, RightCircleOutlined, PhoneOutlined } from '@ant-design/icons'

import Paginator from '../../../components/Paginator'

import { serviceGetQuotationFilters, serviceGetQuotationList } from './services'

import './style.css'
import PageError from '../../../components/Errors/PageError'

export default function Quotation(props) {
	let { pharmacy, status, type, page } = useParams(props)
	const history = useHistory()
	const [loading, setLoading] = useState(true)
	const [quotations, setQuotations] = useState([])
	const [quotationFilters, setQuotationFilters] = useState({
		filterSelected: type,
		filterList: [],
	})

	useEffect(() => {
		let mounted = true
		;(async () => {
			setLoading(true)
			let responseFilters = await serviceGetQuotationFilters()
			let response = await serviceGetQuotationList({
				pharmacy,
				status,
				type,
				page,
			})
			if (!mounted) return
			setQuotationFilters((pvSt) => ({ ...pvSt, filterList: responseFilters }))
			setQuotations(response)
			setLoading(false)
		})()
		return () => {
			mounted = false
		}
	}, [pharmacy, status, type, page])

	if (loading) {
		return (
			<div className='ph-amp-spinner-container'>
				<Spin size='large' />
			</div>
		)
	}
	if ('error' in quotations) {
		return <PageError detailError={quotations} />
	}
	return (
		<>
			<div>
				<Row>
					<Col span={17}>
						<h1 className='ph-ampp-list-main-title-tracking'>Solicitudes</h1>
					</Col>
					{pharmacy !== 'general' && (
						<Col>
							<Select
								placeholder='Tipo de Solicitud'
								onChange={(type) => {
									setQuotationFilters((pvSt) => ({ ...pvSt, filterSelected: type }))
									history.push(`/quotes/${pharmacy}/${status}/${type}/1`)
								}}
								style={{ width: '180px' }}
								defaultValue={quotationFilters.filterSelected}>
								<Select.Option key={0} value={'default'}>
									Todos
								</Select.Option>
								{quotationFilters.filterList.map((filter) => (
									<Select.Option key={filter.order} value={filter.id}>
										{filter.name}
									</Select.Option>
								))}
							</Select>
						</Col>
					)}
				</Row>
				{quotations.data.map((element, i) => (
					<div key={i} className='ph-tracking-list-container'>
						<Row align='middle'>
							{(element.interface?.magistral?.title || element.interface?.on_demand?.title) && (
								<Col xs={1} className='ph-tracking-list-id-orders-container'>
									<div className='ph-order-list-icons-container'>
										<Popover
											content={
												element.interface.magistral?.title || element.interface.on_demand?.title
											}
											trigger='hover'>
											<Avatar
												className='ph-tracking-list-id-orders-icon'
												src={
													element.interface?.magistral?.image.default ||
													element.interface?.on_demand?.image.default
												}
											/>
										</Popover>
									</div>
								</Col>
							)}
							<Col xs={2} className='ph-tracking-list-id-orders-container'>
								<p className='ph-tracking-list-id-orders'>
									<strong className='ph-tracking-list-title-order'>ID Tracking:</strong>
									<br />
									<span className='ph-tracking-list-ids'>{element._id}</span>
								</p>
							</Col>
							<Col xs={2} className='ph-tracking-list-id-orders-container'>
								<p className='ph-tracking-list-id-orders'>
									<strong className='ph-tracking-list-title-order'>Código:</strong>
									<br />
									<span className='ph-tracking-list-ids'>{element.short_code}</span>
								</p>
							</Col>
							<Col xs={4} className='ph-tracking-list-id-orders-container'>
								<span className='ph-tracking-list-status-track'>
									<strong className='ph-tracking-list-title-order'>
										{!!element.quotation
											? `${element.quotation.user_info.first_name} ${element.quotation.user_info.last_name}`
											: `${element.user_info.first_name} ${element.user_info.last_name}`}
									</strong>
									<br />
									<UserOutlined className='ph-tracking-list-icon-circule' />
									{element.quotation?.user_info.email || element.user_info.email}
								</span>
							</Col>
							<Col xs={4} className='ph-tracking-list-id-orders-container'>
								<span className='ph-tracking-list-status-track'>
									<strong className='ph-tracking-list-title-order'>Status:</strong> <br />
									<RightCircleOutlined className='ph-tracking-list-icon-circule' />
									{!!element.process
										? element.process[element.process.length - 1].status_description
										: element.status}
								</span>
							</Col>
							<Col xs={4} className='ph-tracking-list-id-orders-container'>
								<span className='ph-tracking-list-status-track'>
									<strong className='ph-tracking-list-title-order'>Teléfono:</strong> <br />
									<PhoneOutlined className='ph-tracking-list-icon-circule' />
									{element.quotation?.user_info.phone || element.user_info.phone}
								</span>
							</Col>
							<Col xs={2} className='ph-tracking-list-id-orders-container'>
								<Button
									className='ph-tracking-list-buttons'
									href={
										pharmacy !== 'general'
											? `/quote/${pharmacy}/${element._id}`
											: `/quote/general/${element.user_info.rut}/${element.short_code}`
									}>
									Detalle
								</Button>
							</Col>
						</Row>
					</div>
				))}
			</div>
			<Paginator
				route={`/quotes/${pharmacy}/${status}/${type}`}
				page={page}
				totalItems={quotations.totalItems}
				itemsPerPage={quotations.itemsPerPage}
			/>
		</>
	)
}
